import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { RouterPathService } from "../../../../core/common/variables/router-path.service";
import { TranslateService } from "../../../common/variables/translate-service";
import { Options } from '@angular-slider/ngx-slider';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { getAllInverters, selectedInverterCom } from '../../../store/senAppProjects.action';
import { Observable, Subscription } from 'rxjs';
import { SC_Input } from '../../../common/input/SC_Input';
import { SearchInverterService } from "./search-inverter-service";
import { Store } from '@ngrx/store';
import InverterModel from '../../../common/lib/InverterModel';
import * as _ from 'lodash';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'sen-app-search-inverter',
  templateUrl: './search-inverter.component.html',
  styleUrls: ['./search-inverter.component.scss']
})

export class SearchInverterComponent implements OnInit {

  @ViewChild("btnClose") public btnClose: ElementRef;
  sizingMinValue = 80;
  sizingMaxValue = 140;
  sizingOptions: Options = {
    floor: 70,
    ceil: 150,
    translate: (value: number): string => {
      return value + '%';
    }
  };
  prevPath: string;
  nextPath: string;
  inverter = new FormControl([], Validators.required);
  allInverters$: Observable<any[]>;
  allInvertersUnSubscribe: Subscription;
  sPanel = SC_Input.sPanel;
  displayedColumns: string[] = ['enum', 'name'];
  dataSource = new MatTableDataSource;
  cosPhi = new FormControl(1, [Validators.required, Validators.min(0.01), Validators.max(1)]);
  panelCount: number = SC_Input.sInverter.panelCount;
  selectedInverterCombo: any;
  inverterPlanName: string;

  constructor(private routerPath: RouterPathService,
    public SIService: SearchInverterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    public translate: TranslateService,
    private store: Store<any>) {
    this.prevPath = this.routerPath.MPProjectPath;
    this.nextPath = `..${this.routerPath.pathSeperator}${this.routerPath.IPCustomizeString}`;
    this.allInverters$ = this.store.select(state => { return state.appData.allInverters });
  }

  ngOnInit(): void {
    this.SIService.getAllInverter();
    if (SC_Input.sInverter.subGenerators && SC_Input.sInverter.subGenerators.length || SC_Input.sInverter.invalid) {
      this.cosPhi.setValue(SC_Input.sInverter.cosPhi);
      this.SIService.cosPhi = SC_Input.sInverter.cosPhi;
      this.panelCount = this.SIService.panelCount = SC_Input.sInverter.panelCount;
      this.sizingMinValue = this.SIService.factorMin = SC_Input.sInverter.dimensionMin;
      this.sizingMaxValue = this.SIService.factorMax = SC_Input.sInverter.dimensionMax;
      this.inverter.setValue(_.map(SC_Input.sInverter.inverterGroups, 'id'));
    }
  }

  ngOnDestroy() {
    if (this.allInvertersUnSubscribe) this.allInvertersUnSubscribe.unsubscribe();
  }

  setInveterCombo(row: any) {
    this.selectedInverterCombo = row;
    this.store.dispatch(selectedInverterCom(this.selectedInverterCombo));
  }

  getInverterGroups() {
    let IG: any = [];
    this.inverter.value.forEach((i: any) => {
      IG.push(_.find(this.SIService.inverterGroups, { id: i }))
    });
    return IG;
  }

  searchInverters() {
    this.cosPhi.markAsDirty();
    this.inverter.markAsDirty();
    if (this.inverter.invalid || this.cosPhi.invalid) return;
    this.allInvertersUnSubscribe = this.allInverters$.subscribe(data => {
      this.SIService.setCosPhi(this.cosPhi.value);
      this.SIService.setPanelCount(this.panelCount);
      this.SIService.selectPanel(this.sPanel);
      this.SIService.setFactor(this.sizingMinValue / 100, this.sizingMaxValue / 100);
      this.selectedInverterCombo = null;
      this.SIService.selectInverters(this.getInverterGroups());
      this.dataSource = new MatTableDataSource(this.SIService.listCombinations());
    })
  }

  onNextClick() {
    // if (!(SC_Input.sInverter.subGenerators && SC_Input.sInverter.subGenerators.length) && !this.selectedInverterCombo) {
    //   this._snackBar.open(this.translate.getLng('INVERTER_COMBO_MESSAGE'));
    //   return;
    // }
    SC_Input.sInverter.cosPhi = this.cosPhi.value;
    SC_Input.sInverter.dimensionMax = this.sizingMaxValue;
    SC_Input.sInverter.dimensionMin = this.sizingMinValue;
    SC_Input.sInverter.inverterGroups = this.getInverterGroups();
    if (this.selectedInverterCombo) {
      SC_Input.sInverter.subGenerators = [];
      let setups = this.SIService.generateSetupCombination(this.selectedInverterCombo.setups);
      SC_Input.sInverter.subGenerators = this.SIService.addMpptToSetups(setups, SC_Input.sInverter.subGenerators.length)
    }
    this.router.navigate([this.nextPath], { relativeTo: this.route });
  }
}
